<template>
  <b-card class="shadow" style="min-height: 700px" id="printme">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">
            {{ $t("Relatório Mensal do Município") }}
          </h1>

          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="filter === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'weekly' ? 'active' : ''"
              @click="updateAnalytics('weekly')"
            >
              <i class="fas fa-calendar-week"></i>
              {{ $t("Weekly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'monthly' ? 'active' : ''"
              @click="updateAnalytics('monthly')"
            >
              <i class="fas fa-calendar-alt"></i>
              {{ $t("Monthly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'yearly' ? 'active' : ''"
              @click="updateAnalytics('yearly')"
            >
              <i class="fas fa-calendar"></i>
              {{ $t("Yearly") }}
            </b-button>
          </b-button-group>
        </div>
      </div>
      <div class="col-12" v-if="filter">
        <!-- Filtros -->
        <form @submit.prevent="getAnalytics" ref="addItem">
          <div class="row">
            <form-calendar
              v-model="data_inicio"
              grid="6"
              label="Data de início da inserção do registro"
            />

            <form-calendar
              v-model="data_fim"
              grid="6"
              label="Data final da inserção do registro"
            />
          </div>
          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button class="btn btn-default" @click="viewFilters">
                <i class="fas fa-times"></i>
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-12" id="boxPrint">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <div id="headerprint">
          <print-header></print-header>
        </div>
        <div id="reportprint">
          <div id="bodyprint">
            <table class="table table-bordered">
              <thead>
                <tr v-if="report.periodo">
                  <th colspan="2">
                    Período: {{ report.periodo.inicio | formatDate() }} -
                    {{ report.periodo.fim | formatDate() }}
                  </th>
                </tr>
                <tr>
                  <th>Descrição</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2">Sistema</td>
                </tr>
                <tr>
                  <td>Quantidade total de acessos</td>
                  <td>{{ report.acessos }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th colspan="2">
                            Quantidade total de acessos por unidade
                          </th>
                        </tr>
                        <tr>
                          <th>Nome da unidade</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tr
                        v-for="item in report.acessos_unidade"
                        :key="item.unidade_id"
                      >
                        <td>{{ item.nome }}</td>
                        <td>{{ item.total }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <th colspan="2">Famílias</th>
                </tr>
                <tr>
                  <td>Número de Famílias cadastradas</td>
                  <td>{{ report.familias_cadastradas }}</td>
                </tr>
                <tr>
                  <td>Número de Famílias em acompanhamento ativo</td>
                  <td>{{ report.familias_paf_ativo }}</td>
                </tr>
                <tr>
                  <td>Número de Famílias novas inseridas em acompanhamento</td>
                  <td>{{ report.familias_paf_novas }}</td>
                </tr>
                <tr>
                  <th colspan="2">Atendimentos</th>
                </tr>
                <tr>
                  <td>Número Total de Atendimentos realizados</td>
                  <td>{{ report.atendimentos }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th colspan="2">
                            Número de Atendimentos realizados por unidade
                          </th>
                        </tr>
                        <tr>
                          <th>Nome da unidade</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tr
                        v-for="item in report.atendimentos_unidades"
                        :key="item.unidade_id"
                      >
                        <td>{{ item.nome }}</td>
                        <td>{{ item.total }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th colspan="2">Tipos de Atendimentos</th>
                        </tr>
                        <tr>
                          <th>Tipo</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tr
                        v-for="item in report.atendimentos_tipos"
                        :key="item.descricao"
                      >
                        <td>{{ item.descricao }}</td>
                        <td>{{ item.total }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colspan="2">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th colspan="2">
                            Tipos de Atendimentos por Unidades
                          </th>
                        </tr>
                      </thead>
                      <tr
                        v-for="(
                          value, index
                        ) in report.atendimentos_tipos_unidades"
                        :key="index"
                      >
                        <td colspan="2">
                          <table class="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th colspan="2">
                                  {{ index }}
                                </th>
                              </tr>
                              <tr>
                                <th>Descrição</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tr v-for="item in value" :key="item.descricao">
                              <td>
                                {{ item.descricao }}
                              </td>
                              <td>
                                {{ item.total }}
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <th colspan="2">Encaminhamentos</th>
                </tr>
                <tr>
                  <td>Número Total de Encaminhamentos realizados</td>
                  <td>{{ report.encaminhamentos }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th colspan="2">
                            Número de Encaminhamentos realizados por unidade
                          </th>
                        </tr>
                        <tr>
                          <th>Nome da unidade</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tr
                        v-for="item in report.encaminhamentos_unidades"
                        :key="item.unidade_id"
                      >
                        <td>{{ item.nome }}</td>
                        <td>{{ item.total }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <th colspan="2">SCFV</th>
                </tr>
                <tr>
                  <td>Número de grupos ativos do SCFV</td>
                  <td>{{ report.grupos_scfv }}</td>
                </tr>
                <tr>
                  <td>Número de usuários ativos no SCFV</td>
                  <td>{{ report.grupos_scfv_usuarios }}</td>
                </tr>
                <tr>
                  <td>Número de novos usuários ativos no SCFV no período</td>
                  <td>{{ report.grupos_scfv_usuarios_novos }}</td>
                </tr>

                <tr>
                  <th colspan="2">Proteção Especial</th>
                </tr>
                <tr>
                  <td>
                    Número de atendimentos com status de violência ou violação
                    de direito
                  </td>
                  <td>{{ report.vvd }}</td>
                </tr>
                <tr>
                  <td>Número de indícios</td>
                  <td>{{ report.vvd_indicio }}</td>
                </tr>
                <tr>
                  <td>Número de confirmados</td>
                  <td>{{ report.vvd_confirmada }}</td>
                </tr>

                <tr>
                  <td colspan="2">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th colspan="2">Número de violação por situação:</th>
                        </tr>
                        <tr>
                          <th>Situação</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(value, index) in report.vvd_situacao"
                          :key="index"
                        >
                          <td>
                            {{ index }}
                          </td>
                          <td>
                            {{ value }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-print mt-4">
      <div class="col-lg-12 col-md-12 text-center align-items-center">
        <b-button
          :title="$t('Visualizar e Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="print()"
        >
          <i class="fas fa-print"></i>
        </b-button>

      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "RelatorioGestor",
  data() {
    return {
      loading: true,
      range: "monthly",
      report: [],
      filtros: {
        unidade: null,
      },
      tecnicos: [],
      tipos: [],
      data_inicio: "",
      data_fim: "",
      isLoadingMsg: false,
      filter: false,
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      role: null,
      loadingStatus: false,
    };
  },
  mounted() {
    this.getAnalytics();
  },
  methods: {
    viewFilters: function () {
      this.filter = !this.filter;
      // some code to filter users
    },
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      this.loading = true;

      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      axios
        .get("api/dashboard/relatorio/gestor", {
          params: {
            range: this.range,
            filtros: this.filtros,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

